export default /* glsl */ `
uniform vec3 wipeColor;
uniform float wipePosition;
uniform float wipeMetalness;

varying float vWipeFactor;
`;
